import { defineComponent as _defineComponent } from 'vue'
import { CloseBold } from '@element-plus/icons-vue';
import { PropType, reactive, watch, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'editBaseInfo',
  props: {
  baseVisible: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
  baseInfo: {
    type: Object as PropType<any>,
    default: () => { },
  },
},
  emits: ['close', 'save'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emits = __emit;

const props = __props;

const baseForm = reactive({
  appName: '',
  appDescription: '',
  hasVOIP: false,
});

const baseFormRef = ref();
const baseRules = {
  appName: [{ required: true, message: '请输入应用名称', trigger: 'blur' }],
  appDescription: [{ required: true, message: '请输入应用描述', trigger: 'blur' }],
};

watch(
  () => props.baseInfo,
  (newVal) => {
    baseForm.appName = newVal.appName;
    baseForm.appDescription = newVal.appDescription;
    baseForm.hasVOIP = newVal.hasVOIP;
  },
  { immediate: true, deep: true }
);

const handleClose = () => {
  baseFormRef.value?.resetFields();
  emits('close');
};

const submit = async () => {
  if (!baseFormRef.value) return;
  await baseFormRef.value.validate((valid: boolean) => {
    if (valid) {
      emits('save', baseForm);
      handleClose();
    }
  });
};

const __returned__ = { emits, props, baseForm, baseFormRef, baseRules, handleClose, submit, get CloseBold() { return CloseBold } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})